export default __webpack_public_path__ + "static/media/CentreForAccessibility.a2c97ed8.png";